import React from 'react';
import { TargetIcon } from 'lucide-react';
import { Typography } from 'antd';
import { AICampaignFormData } from '../types';

const { Title } = Typography;

interface StepOneProps {
	formData: AICampaignFormData;
	setFormData: React.Dispatch<React.SetStateAction<AICampaignFormData>>;
	handleInputChange: (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
}

const StepOne: React.FC<StepOneProps> = ({ formData, setFormData, handleInputChange }) => {
	return (
		<div className="step-content">
			<div className="flex">
				<TargetIcon size={36} className="text-blue-600 mr-3" />
				<Title className="my-0" level={2}>
					What's your campaign goal?
				</Title>
			</div>

			<p>
				Tell us what you're trying to achieve with this outbound campaign. Being specific helps our
				AI craft more effective messaging.
			</p>

			<div className="mb-2">
				<label className="block text-sm font-medium text-gray-700 mb-2">
					Campaign Name
					<span className="text-red-500 ml-1">*</span>
				</label>
				<input
					type="text"
					name="name"
					value={formData.name}
					onChange={handleInputChange}
					placeholder="e.g., Q4 Sales Outreach"
					className="form-input w-full"
					required
				/>
			</div>

			<label className="block text-sm font-medium text-gray-700 mb-2">
				Campaign Goal
				<span className="text-red-500 ml-1">*</span>
			</label>
			<textarea
				name="campaignGoal"
				value={formData.campaignGoal}
				onChange={handleInputChange}
				placeholder="e.g., Book more demos, Re-engage cold leads, Promote our new product launch..."
				rows={5}
				className="form-textarea"
				required
			/>
			<div className="example-goals">
				<p>Examples of effective goals:</p>
				<div className="goal-buttons">
					<button
						type="button"
						onClick={() => setFormData({ ...formData, campaignGoal: 'Generate qualified leads' })}
					>
						Generate qualified leads
					</button>
					<button
						type="button"
						onClick={() => setFormData({ ...formData, campaignGoal: 'Book more demos' })}
					>
						Book more demos
					</button>
					<button
						type="button"
						onClick={() => setFormData({ ...formData, campaignGoal: 'Re-engage customers' })}
					>
						Re-engage customers
					</button>
				</div>
			</div>
		</div>
	);
};

export default StepOne;
